import { IReducerAction } from 'src/interfaces/redux';
import { ISubtitles } from 'src/interfaces/PlayerTemplate';
import { ISubtitleStyle } from 'src/interfaces/Subtitle';
import { DEFAULT_SUBTITLE_STYLE } from 'src/services/shared/constants';

export * from './subtitles.selectors';

export interface ISubtitlesState {
  activeTrack: ISubtitles | null;
  subtitles: ISubtitles[] | null;
  currentCueText: string | null;
  subtitleEnabled: boolean;
  style: ISubtitleStyle;
}

export const subtitlesInitialState: ISubtitlesState = {
  activeTrack: null,
  subtitles: null,
  currentCueText: null,
  subtitleEnabled: false,
  style: { ...DEFAULT_SUBTITLE_STYLE },
};

export enum SubtitlesActionTypes {
  SET_ACTIVE_TRACK = 'SUBTITLE/SET_ACTIVE_TRACK',
  SET_SUBTITLES = 'SUBTITLE/SET_SUBTITLES',
  SET_CURRENT_CUE_TEXT = 'SUBTITLE/SET_CURRENT_CUE_TEXT',
  SET_SUBTITLE_STYLE = 'SUBTITLE/SET_SUBTITLE_STYLE',
}

export type ISubtitlesAction = IReducerAction<SubtitlesActionTypes>;

export default function subtitleReducer(state: ISubtitlesState = subtitlesInitialState, action: ISubtitlesAction) {
  switch (action.type) {
    case SubtitlesActionTypes.SET_ACTIVE_TRACK:
      if (!action.payload) return { ...state, subtitleEnabled: false };
      return { ...state, activeTrack: action.payload, subtitleEnabled: true };
    case SubtitlesActionTypes.SET_SUBTITLES:
      return { ...state, subtitles: action.payload };
    case SubtitlesActionTypes.SET_CURRENT_CUE_TEXT:
      return { ...state, currentCueText: action.payload };
    case SubtitlesActionTypes.SET_SUBTITLE_STYLE:
      return { ...state, style: { ...state.style, ...action.payload } };
    default:
      return state;
  }
}
